import { jsx as _jsx } from "react/jsx-runtime";
import { mdiSortAlphabeticalVariant } from '@mdi/js';
import { Icon } from '@mdi/react';
import { Button } from '@mui/material';
import { Box } from '@mui/system';
import { FormattedMessage } from 'react-intl';
import { useSTContext } from '../../SmartTableContext';
const ClearSortButton = () => {
    const { isDefaultSorting, clearSorting } = useSTContext();
    return (_jsx(Box, { children: _jsx(Button, { size: "small", variant: "outlined", disabled: isDefaultSorting, onClick: clearSorting, startIcon: _jsx(Icon, { path: mdiSortAlphabeticalVariant, size: 1 }), children: _jsx(FormattedMessage, { id: "table.configureColumns.clearSort", defaultMessage: "Clear sort" }) }) }));
};
export default ClearSortButton;
//# sourceMappingURL=ClearSortButton.js.map